import React from "react"
import PropTypes from "prop-types"
import { useFocusMode } from "hooks/use-focus-mode"
import { motion } from "framer-motion"

/**
 * This component allows to hide certain parts of the UI when focus mode is enabled.
 * It uses display: none to make those parts of UI not accessible by keyboard and invisible to screen readers.
 *
 * It's meant to be composed with other FocusMode components (eg. FocusModeSlideOut)
 */
export function FocusModeHide({ className, style = {}, children }) {
  const inFocusMode = useFocusMode(state => state.inFocusMode)

  const childVariants = {
    visible: {
      display: "block",
      transition: { duration: 0, delay: 0 }
    },
    hidden: {
      display: "none",
      transition: { duration: 0, delay: 0.24 }
    }
  }

  return (
    <motion.div
      className={className}
      style={style}
      animate={inFocusMode ? "hidden" : "visible"}
      variants={childVariants}
    >
      {children}
    </motion.div>
  )
}

FocusModeHide.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
}
